module.exports = __webpack_public_path__ + "static/media/ball_1_8.b77f4ba9.mp3";